// Shutter button overlay — white circle at bottom-center of the AR view.
// Pressing it captures the AR scene (canvas + logo), excluding this button
// and the Info button (both are HTML overlays, not part of the WebGL canvas).

import { captureAndSave } from '../../utils/captureScene';
import { logger } from '../../utils/logger';

export function mountShutterButton(slot: HTMLElement): () => void {
  const btn = document.createElement('button');
  btn.className = 'ar-shutter-btn';
  btn.setAttribute('aria-label', 'Take photo');
  slot.appendChild(btn);

  let capturing = false;

  const handleClick = async () => {
    if (capturing) return;
    capturing = true;

    // Flash feedback — fades out on animationend.
    const flash = document.createElement('div');
    flash.className = 'ar-shutter-flash';
    slot.appendChild(flash);
    flash.addEventListener('animationend', () => flash.remove(), { once: true });

    try {
      await captureAndSave();
    } catch (err) {
      logger.error('Shutter capture error:', err);
    } finally {
      capturing = false;
    }
  };

  btn.addEventListener('click', handleClick);

  return () => {
    btn.removeEventListener('click', handleClick);
    btn.remove();
  };
}
